;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { useQuery } from '@tanstack/react-query'
import { getStocklistSourceStatusQueries } from 'src/deprecated/api/stocklist-queries'

export function useGetStocklistSourceStatus() {
  const canaryClient = useCanaryClient()
  const stocklistSourceStatus = getStocklistSourceStatusQueries(canaryClient)

  const { data, isLoading } = useQuery({
    ...stocklistSourceStatus.status(),
  })

  return {
    data,
    isLoading,
  }
}
